module.exports = __webpack_public_path__ + "static/media/logo-marceloratton.9a8bada2.svg";